import { ACTIONS } from './types';
import { setFilteredEmergenciesAction } from './set-filtered-emergencies.action';

export const addToAllEmergenciesActionCreator = newEmergency => dispatch => {
    dispatch({
        type: ACTIONS.ADD_TO_ALL_EMERGENCY,
        payload: newEmergency,
    });
    dispatch(setFilteredEmergenciesAction());
}
